var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox',_vm._g({model:{value:(_vm.localModel),callback:function ($$v) {_vm.localModel=$$v},expression:"localModel"}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }